
import React from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

const ProcessSection: React.FC = () => {
  return (
    <section className="section-padding bg-itmgmt-light-gray">
      <div className="container-wide">
        <div className="text-center mb-12">
          <h2 className="heading-lg text-itmgmt-dark-blue mb-4">Our Consulting Process</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We follow a structured approach to understand your business needs and deliver tailored solutions.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <div className="bg-itmgmt-medium-blue rounded-full h-12 w-12 flex items-center justify-center mb-4">
              <span className="text-white font-bold">1</span>
            </div>
            <h3 className="font-bold text-itmgmt-dark-blue text-xl mb-4">Discovery</h3>
            <p className="text-gray-600">
              We take time to understand your business objectives, pain points, and current technology environment.
            </p>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <div className="bg-itmgmt-medium-blue rounded-full h-12 w-12 flex items-center justify-center mb-4">
              <span className="text-white font-bold">2</span>
            </div>
            <h3 className="font-bold text-itmgmt-dark-blue text-xl mb-4">Analysis</h3>
            <p className="text-gray-600">
              We analyze your requirements and identify opportunities for technology to address challenges and drive growth.
            </p>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <div className="bg-itmgmt-medium-blue rounded-full h-12 w-12 flex items-center justify-center mb-4">
              <span className="text-white font-bold">3</span>
            </div>
            <h3 className="font-bold text-itmgmt-dark-blue text-xl mb-4">Recommendations</h3>
            <p className="text-gray-600">
              We provide detailed recommendations with clear roadmaps for implementation and expected outcomes.
            </p>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <div className="bg-itmgmt-medium-blue rounded-full h-12 w-12 flex items-center justify-center mb-4">
              <span className="text-white font-bold">4</span>
            </div>
            <h3 className="font-bold text-itmgmt-dark-blue text-xl mb-4">Implementation</h3>
            <p className="text-gray-600">
              We can either guide your team through implementation or handle it entirely for you based on your preference.
            </p>
          </div>
        </div>
        
        <div className="mt-12 text-center">
          <Button asChild className="button-primary">
            <Link to="/book?service=consulting">Schedule a Strategy Session</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
